export default {
    path: [
        {
            d:
                'M11.5 12C9.70045 12 8.98535 9.9121 8.2937 7.89305C7.6382 5.97915 6.96 4 5.5 4C5.15905 4.02005 4.83179 4.14115 4.55991 4.34787C4.28804 4.55459 4.08386 4.83757 3.9734 5.16075L3.02565 4.8419C3.0508 4.7667 3.6609 3 5.5 3C7.67455 3 8.5061 5.42735 9.24 7.56895C9.84425 9.33335 10.415 11 11.5 11C11.841 10.98 12.1682 10.8589 12.4401 10.6521C12.712 10.4454 12.9161 10.1624 13.0266 9.83925L13.9743 10.1581C13.9492 10.2333 13.3391 12 11.5 12Z',
        },
        {
            d:
                'M2 14V8.5H3V7.5H2V1H1V14C1 14.2652 1.10536 14.5196 1.29289 14.7071C1.48043 14.8946 1.73478 15 2 15H15V14H2Z',
        },
        {
            d: 'M5 7.5H4V8.5H5V7.5Z',
        },
        {
            d: 'M7 7.5H6V8.5H7V7.5Z',
        },
        {
            d: 'M11 7.5H10V8.5H11V7.5Z',
        },
        {
            d: 'M13 7.5H12V8.5H13V7.5Z',
        },
        {
            d: 'M15 7.5H14V8.5H15V7.5Z',
        },
    ],
    viewBox: '0 0 16 16',
}
